import { __extends } from "tslib";
import { TraitInfo } from './TraitInfo';
import { typeDefaultValues } from './typeDefaultValues';
var SlotTraitInfo = /** @class */ (function (_super) {
    __extends(SlotTraitInfo, _super);
    function SlotTraitInfo(abc, kind, name, slot, typeName, defaultValueKind, defaultValueIndex) {
        var _this = _super.call(this, abc, kind, name) || this;
        _this.slot = slot;
        _this.typeName = typeName;
        _this.defaultValueKind = defaultValueKind;
        _this.defaultValueIndex = defaultValueIndex;
        return _this;
    }
    SlotTraitInfo.prototype.resolve = function () {
        _super.prototype.resolve.call(this);
        if (typeof this.typeName === 'number') {
            this.typeName = this.abc.getMultiname(this.typeName);
        }
    };
    SlotTraitInfo.prototype.getTypeName = function () {
        this.resolve();
        return this.typeName;
    };
    SlotTraitInfo.prototype.getDefaultValue = function () {
        if (this.defaultValueKind === -1) {
            if (this.typeName === null) {
                return undefined;
            }
            var value = typeDefaultValues[this.typeName.getMangledName()];
            return value === undefined ? null : value;
        }
        return this.abc.getConstant(this.defaultValueKind, this.defaultValueIndex);
    };
    return SlotTraitInfo;
}(TraitInfo));
export { SlotTraitInfo };
